export default __webpack_public_path__ + "static/human resources-26eee31ba49d8f0e3f07b9595bf66725.webp";